'use client'

import styles from '@/styles/product-detail/product-description.module.scss'
import { useEffect, useState, useCallback, useRef } from 'react'
import Image from 'next/image'
import { Add } from '@react-vant/icons';
// import FineMore from './FineMore';
import productApi from '@/service/modules/productApi'
import Dialog from "@/components/global/Dialog";
import { toast } from '@/components/global/Toast';

export default function ProductDescription(props: any) {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const hasRequestedRef = useRef(false)
  const [shouldLoadDetail, setShouldLoadDetail] = useState(false)
  const [descriptionHtml, setDescriptionHtml] = useState("")
  const [videoList, setVideoList]: any = useState([])
  const [dimension, setDimension] = useState({} as any)
  const [featuresHtml, setfeaturesHtml] = useState("")
  const [specificationHtml, setspecificationHtml] = useState("")
  const [warrantyHtml, setWarrantyHtml] = useState("")
  const [customList, setCustomList]: any = useState([])

  const imgRegex = /<img[^>]+>/g;
  const tableRegex = /<table[^>]+>/g;

  const upDateRichText = (richText: string) => {
    return richText
      .replace(imgRegex, (match) => {
        // 正则表达式模式匹配img标签的src和alt属性，无论它们的顺序如何
        const pattern = /<img[^>]*?(src|alt)=["'](.*?)["'][^>]*?(src|alt)=["'](.*?)["'][^>]*?>/g;

        let srcValue = '';
        let altValue = '';

        let matchResult: RegExpExecArray | null;

        while ((matchResult = pattern.exec(match))) {
          const attribute1 = matchResult[1];
          const value1 = matchResult[2];
          const attribute2 = matchResult[3];
          const value2 = matchResult[4];

          if (attribute1 === 'src') {
            srcValue = value1;
          } else if (attribute2 === 'src') {
            srcValue = value2;
          }

          if (attribute1 === 'alt') {
            altValue = value1;
          } else if (attribute2 === 'alt') {
            altValue = value2;
          }
        }

        if (srcValue) {
          // 将原本的img标签, 替换为next的image组件，以实现懒加载
          return `<Image
            key="${srcValue}"
            src="${srcValue}"
            alt="${altValue}"
            width={650}
            height={650}
            style='width: 100%; max-height: 100%;'
            loading="lazy"
          />`
        } else {
          console.log('description No img tag found or matching failed');
          return match.replace(">", " style='width: 100%; max-height: 100%;'>");
        }
      })
      // 移除所有HTML标签的style属性
      .replace(/\s+style\s*=\s*["'][^"']*["']/gi, '')
  }

  const upDateTable = (richText: string) => {
    if (!richText) {
      return ""
    }
    return richText
      .replace(/style=/g, "")
      .replace(tableRegex, (match) => {
        return match.replace(">", " style='width: 100% !important;'>");
      })
  }

  const getDetail = useCallback(async () => {
    try {
      const res = await productApi.getDescription(props.productID)
      const { description, video, dimension } = res.data
      if (description) {
        const { features, product, specification, warranty } = description
        const newTabs = []
        if (product || props.courierID == 11) {
          newTabs.push({
            // key: 'goods-detail',
            key: 'description-box',
            label: 'Description'
          })
        }
        if (features) {
          newTabs.push({
            key: 'features-box',
            label: 'Features'
          })
        }
        if (specification) {
          newTabs.push({
            key: 'specification-box',
            label: 'Specification'
          })
        }
        const html = `<p style="font-weight:bold;margin-top:8px;"><br/>This item is an authentic parallel-import and items will be shipped from our supplier's warehouse and may take 2 to 3 days processing after payment confirmation. Parcel will be sent out by <b>DHL / UPS Courier Service</b> and may take 3 to 7 working days for delivery.<br/>If this product requires a charger, An Australian Certified Charger will be provided with this product instead of the original charger.(*Selected product only)</p>`
        let newDescriptionHtml = product ? product.content : ""
        if (props.courierID == 11) {
          newDescriptionHtml = newDescriptionHtml + html
        }

        if (newDescriptionHtml) setDescriptionHtml(`${upDateRichText(newDescriptionHtml)}`) 
        if (features) setfeaturesHtml(upDateTable(features.content))
        if (specification) setspecificationHtml(upDateTable(specification.content))
        if (warranty) {
          // 替换warranty内容中的链接
          let warrantyContent = warranty.content
          // 先替换路径部分
          warrantyContent = warrantyContent.replace(/\/article\/faqdetails\/12/g, "/article/TermsAndConditions#Warranty")
          warrantyContent = warrantyContent.replace(/\/contact-us/g, "/contact")
          // 再替换域名部分
          warrantyContent = warrantyContent.replace(/https:\/\/www\.crazysales\.com\.au/g, "https://m.crazysales.com.au")
          setWarrantyHtml(warrantyContent)
        }

        // features, product, specification, warranty以外的属性
        const blackList = ["features", "product", "specification", "warranty"]
        const customList = []
        for (const key in description) {
          if (Object.prototype.hasOwnProperty.call(description, key) && blackList.indexOf(key) == -1) {
            const element = description[key];
            newTabs.push({
              key: element.title,
              label: element.title
            })
            customList.push({
              name: element.title,
              html: element.content
            })
          }
        }
        setCustomList(customList)
      }

      if (video && video.length) {
        setVideoList(video)
      }

      if (dimension) {
        setDimension(dimension)
      }
    } catch (error: any) {
      toast.show(error.message)
    }
  }, [props.productID, props.courierID])

  // 靠近可视区域时，再触发详情请求，减少首屏无关资源加载
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const target = containerRef.current
    if (!target) {
      return
    }

    if (!('IntersectionObserver' in window)) {
      setShouldLoadDetail(true)
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting)
        if (isVisible) {
          setShouldLoadDetail(true)
          observer.disconnect()
        }
      },
      {
        root: null,
        rootMargin: '200px 0px',
        threshold: 0.01,
      }
    )

    observer.observe(target)

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    if (!shouldLoadDetail || hasRequestedRef.current) {
      return
    }
    hasRequestedRef.current = true
    getDetail()
  }, [shouldLoadDetail, getDetail])

  // 图片触摸事件处理
  // useEffect(() => {
  //   const productDiv = document.getElementById('description-box');
  //   const imgElements = productDiv?.querySelectorAll('img');
    
  //   if (!imgElements?.length) return;
    
  //   // 为每个图片添加触摸事件监听器
  //   imgElements.forEach((img) => {
  //     img.addEventListener('touchstart', handleImageTouch);
  //   });
    
  //   // 清理函数
  //   return () => {
  //     imgElements.forEach((img) => {
  //       img.removeEventListener('touchstart', handleImageTouch);
  //     });
  //   };
  // }, [descriptionHtml])

  // const [pinkitUrl, setPinkkitUrl] = useState("")
  // // 处理图片触摸事件的函数
  // const handleImageTouch = (event: any) => {    
  //   const img = event.target;
  //   const url = props.url;
  //   const media = img.src;
  //   const description = props.name;
  //   let pos = media.indexOf("//") + 2;
  //   pos = pos >= 0 ? pos : 0;
  //   const leg = media.length;
  //   const ulrstr = media.slice(pos, leg);

  //   setPinkkitUrl("http://www.pinterest.com/pin/create/button/?url=" + url + "&media=http%3A%2F%2F" + ulrstr + "&description=" + description)

  //   // 获取被触摸图片的位置信息
  //   const imgPosition = img.getBoundingClientRect();
    
  //   const pinkit = document.getElementById("pinkit-btn");
    
  //   if (pinkit) {
  //     // 将pinkit-btn移动到图片的右上角
  //     pinkit.style.position = 'absolute';
  //     pinkit.style.right = `${imgPosition.left}px`; // 减去按钮宽度，使其在右上角
  //     pinkit.style.top = `${img.offsetTop}px`;
  //     pinkit.style.display = 'block';
  //     pinkit.style.zIndex = '1000';
  //   }
  // }

  // 检查 URL 是否以视频格式后缀结尾
  const isDirectVideo = (url: string): boolean => {
    return url.match(/\.(mp4|mkv|webm|avi|mov|flv|wmv|m4v|mpg|mpeg)$/i) != null;
  };

  return (
    <div className={styles['comp-product-description']} id="goods-detail" ref={containerRef}>
      <div className={styles['goods-info']}>
        {
          !!(props.preSales != 0 && props.preSales)
          &&
          <PreSaleContent />
        }
        
        {
          featuresHtml
          &&
          <div className={styles['features-box']} id="features-box">
            <div className={styles['title']}>Features:</div>
            <div dangerouslySetInnerHTML={{ __html: featuresHtml }}></div>
          </div>
        }

        {
          specificationHtml
          &&
          <div className={styles['specification-box']} id="specification-box">
            <div className={styles['title']}>Specification:</div>
            <div style={{ overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: specificationHtml }}></div>
          </div>
        }
        
        {
          dimension
          &&
          <div className={styles['dimension-box']} id="dimension-box">
            <div className={styles['title']}>Package Dimension:</div>
            <div className={styles['dimension-line']}>
              <div className={styles['dimension-line-title']}>Width</div>
              <div className={styles['dimension-line-content']}>{dimension.width}</div>
            </div>
            <div className={styles['dimension-line']}>
              <div className={styles['dimension-line-title']}>Height</div>
              <div className={styles['dimension-line-content']}>{dimension.height}</div>
            </div>
            <div className={styles['dimension-line']}>
              <div className={styles['dimension-line-title']}>Length</div>
              <div className={styles['dimension-line-content']}>{dimension.length}</div>
            </div>
            <div className={styles['dimension-line']}>
              <div className={styles['dimension-line-title']}>Weight</div>
              <div className={styles['dimension-line-content']}>{dimension.weight}</div>
            </div>
          </div>
        }

        {
          !!(descriptionHtml || videoList.length)
          &&
          <div className={styles['description-box']} id="description-box">
            <div className={styles['title']}>Item Description:</div>

            {
              !!(videoList && videoList.length) &&
              videoList.map((videoUrl: any, index: number) => {
                if (isDirectVideo(videoUrl)) {
                  return (
                    <video key={index} controls width="100%">
                      <source src={videoUrl} type={`video/${videoUrl.split('.').pop()}`} />
                      Your browser does not support the HTML5 video tag.
                    </video>
                  );
                } else {
                  // 如果是 YouTube 链接，需要转换为嵌入格式
                  let embedUrl = videoUrl;
                  if (videoUrl.includes('youtu.be') || videoUrl.includes('youtube.com')) {
                    embedUrl = videoUrl.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=', 'embed/');
                  }
                  // 如果需要支持其他视频服务，请在此添加更多的条件语句
                  return (
                    <iframe
                      key={index}
                      width="100%"
                      src={embedUrl}
                      style={{ border: '0', height: '52vw' }}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  );
                }
              })
            }

            <div className={styles['rich-text']} dangerouslySetInnerHTML={{ __html: descriptionHtml }}></div>

            {/* <Link href={pinkitUrl} target="_blank">
              <Image
                className={styles["pinit-icon"]}
                id="pinkit-btn"
                src={`${process.env.IMAGE_DOMAIN}/svg/product-detail/pin-it.svg`}
                alt="pinkit"
                width={50}
                height={50}
              />
            </Link> */}
          </div>
        }

        {/* <FineMore breadcrumb={props.breadcrumb} /> */}

        <>
          {
            !!(props.ISBN && props.ISBN != 0)
            &&
            <p><strong>ISBN: </strong>{props.ISBN}</p>
          }
          {
            !!(props.MPN && props.MPN != 0)
            &&
            <p><strong>MPN: </strong>{props.MPN}</p>
          }
          {
            !!(props.UPC && props.UPC != 0)
            &&
            <p><strong>UPC: </strong>{props.UPC}</p>
          }
          {
            !!(props.vintage && props.vintage != 0)
            &&
            <p><strong>VINTAGE: </strong>{props.vintage}</p>
          }
        </>

        {/* 其他自定义属性 */}
        {
          customList.map((v: any) => (
            <div className={styles['custom-box']} id={v.name} key={v.name}>
              <div className={styles['title']}>{v.name}:</div>
              <div dangerouslySetInnerHTML={{ __html: v.html }}></div>
            </div>
          ))
        }

        {
          warrantyHtml
          &&
          <div className={styles['warranty-box']} id="warranty-box">
            <div className={styles['title']}>Warranty:</div>
            <div style={{ overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: warrantyHtml }}></div>
          </div>
        }
        
        {
          !!(props.preSales != 0 && props.preSales)
          &&
          <div className={styles['warranty-box']} style={{ color: '#D70B17' }}>
            * 'shipped' timeframe is an estimate of when the item ordered will ship from our warehouse. The items you have ordered will be shipped as soon as they become available
          </div>
        }

        {/* <FineMore productID={props.productID} /> */}
      </div>
    </div>
  )
}

function PreSaleContent() {
  const [showPreSaleDialog, setShowPreSaleDialog] = useState(false);

  return (
    <>
      <div className={styles['pre-sale-content']}>
        <Image
          className={styles['img-box']}
          src='https://img.crazysales.com.au/images/newhomepage/total/detail-30-days.png'
          alt='img'
          width={650}
          height={200}
        />
        <div 
          className={styles['apply-line']} 
          onClick={() => setShowPreSaleDialog(true)}
        >
          *Terms and conditions apply <Add color='#999999' style={{ marginLeft: '4px', marginTop: '2px' }}  />
        </div>
      </div>
      
      <Dialog
        visible={showPreSaleDialog}
        title="Terms and conditions apply"
        closeable={true}
        showConfirmButton={true}
        showCancelButton={false}  
        confirmButtonText="Got it !"
        onCancel={() => setShowPreSaleDialog(false)}
        onConfirm={() => {
          setShowPreSaleDialog(false);
        }}
      >
        <div
          className={styles["pre-sale-dialog"]}
          style={{
            width: "100%",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          <ul className={styles['modal']}>
            <li className={styles['tips']}>1.30 days pre-order price guarantee applies to all pre-order items on sales in m.crazysales.com.au; www.crazysales.com.au</li>
            <li className={styles['tips']}>2.30 days refer to 30 calendar days after your order starts processing for delivery in our warehouse; 30 days period exclude following special promotion: Flash sales, End of financial year, Click Frenzy, Black Friday, Christmas promotion, Boxing day promotion</li>
            <li className={styles['tips']}>3.Differences will be refund in form of Crazy Points, please contact our customer service with your order details and evident of lower price by e-mail to info@crazysales.com.au</li>
          </ul>
        </div>
      </Dialog>
    </>

  )
}